import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.onScroll = this.handleScroll.bind(this);
        this.onResize = this.updateTopEventBorder.bind(this);

        const savedEventId = localStorage.getItem("topVisibleEventId");

        if (savedEventId) {
            const element = this.element.querySelector(`[data-event-id="${savedEventId}"]`);
            if (element) {
                element.scrollIntoView({ behavior: 'instant', block: 'start' });
            }
        }

        this.element.addEventListener("scroll", this.onScroll);
        window.addEventListener("resize", this.onResize);

        this.updateTopEventBorder();
        this.element.classList.remove('opacity-0');
    }

    handleScroll() {
        this.saveTopVisibleEvent();
        this.updateTopEventBorder();
    }

    saveTopVisibleEvent() {
        const topVisibleEvent = this.getTopVisibleEvent();
        if (topVisibleEvent) {
            localStorage.setItem("topVisibleEventId", topVisibleEvent.dataset.eventId);
        }
    }

    getTopVisibleEvent() {
        const scrollableItems = this.element.querySelectorAll('.event-item, .month-title');
        const containerTop = this.element.getBoundingClientRect().top;
        const containerBottom = containerTop + this.element.clientHeight;

        let topVisibleItem = null;
        let smallestDistanceFromTop = Infinity;

        for (let item of scrollableItems) {
            const itemRect = item.getBoundingClientRect();

            if (itemRect.bottom > containerTop && itemRect.top < containerBottom) {
                const distanceFromTop = Math.abs(itemRect.top - containerTop);

                if (distanceFromTop < smallestDistanceFromTop) {
                    smallestDistanceFromTop = distanceFromTop;
                    topVisibleItem = item;
                }
            }
        }

        return topVisibleItem;
    }

    updateTopEventBorder() {
        const allEventItems = this.element.querySelectorAll('.event-item');
        allEventItems.forEach(item => {
            item.classList.remove('border-2', 'border-black');
        });

        if (window.innerWidth >= 1024) {
            return;
        }

        const topVisibleEvent = this.getTopVisibleEvent();
        if (topVisibleEvent && topVisibleEvent.classList.contains('event-item')) {
            topVisibleEvent.classList.add('border-2', 'border-black');
        }
    }

    disconnect() {
        this.element.removeEventListener("scroll", this.onScroll);
        window.removeEventListener('resize', this.onResize);
    }
}
